// Table Base Layer: Wood grain, beveled edge, lighting
import * as PIXI from 'pixi.js';
import { hexToPixi } from './colorUtils';

export function createTableBase(width: number, height: number, theme: { tableBase: string; accent: string }) {
  const container = new PIXI.Container();

  // Table base ellipse
  const base = new PIXI.Graphics();
  base.ellipse(width / 2, height / 2, width * 0.45, height * 0.23).fill({ color: hexToPixi(theme.tableBase) });

  // Beveled edge (accent)
  const edge = new PIXI.Graphics();
  edge.ellipse(width / 2, height / 2, width * 0.45, height * 0.23).stroke({
    width: 16,
    color: hexToPixi(theme.accent),
    alpha: 0.7,
  });

  // Simple lighting overlay (semi-transparent white ellipse)
  const lighting = new PIXI.Graphics();
  lighting.ellipse(width / 2, height / 2.5, width * 0.22, height * 0.08).fill({ color: 0xffffff, alpha: 0.13 });

  container.addChild(base, edge, lighting);
  return container;
}
